// action type
import { actionTypes } from '../actionTypes';

// interface
import { IProductionReportsState } from '../../model/productionReports';

// filter
import {filterProductionReportShippingData, getFilterDropDownData } from './productionReportsFilters';

// reducer
export const productionReportReducer = (state: IProductionReportsState[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_PRODUCTION_REPORTS_SUCCESS:
      return {
        ProductionReportArrays: filterProductionReportShippingData(action.payload)
      }
    case actionTypes.LOAD_PRODUCTION_FILTER_SUCCESS:
    return {
      FilterDropDown: getFilterDropDownData(action.payload)
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/productionReports/reducer.ts